import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import { ReactComponent as StarFillIcon } from '../../../../../../assets/icons/ic_star.svg';
import SlotBookingReviewItem from './SlotBookingReviewItem';

const SlotBookingReview = ({details}) => {
    const dictionary = useDictionary();
    let reviews = details?.reviews ?? [];
    const CalculateTotalReviewsAndAvg = () => {
        const totalReviews = reviews.reduce((sum, item) => sum + Number(item.rating), 0);
        const avgRating = parseFloat(totalReviews / reviews.length).toFixed(1);
    
        return (
            <div className='d-flex' style={{gap: 4}}>
                <div>{avgRating}</div>
                <StarFillIcon width={12} height={12} style={{ color: '#22264C9', padding:'2px 0px' }} />
                <div>({reviews.length} {dictionary.providerReviews.toLowerCase()})</div>
            </div>
        );
    };
    
    return (
        <div className="detail-tab-container thin-scrollbar" style={{padding: 30}}>
            <div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '16px' }}
			>
				<h3 style={{fontWeight: 500,fontSize: 16}}>
					{dictionary.providerReviews}
				</h3>
				<div
					style={{ fontWeight: 'normal', opacity: '0.6' }}
					className="booking-number"
				>
					{CalculateTotalReviewsAndAvg()}
				</div>
			</div>
            {
                (reviews && reviews.length > 0) ? (
                    <div className='review_main_wrapper'>
                        {reviews.map(item => (
                            <SlotBookingReviewItem
                                key={item.id}
                                review={item}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="empty-provider-customers-list-placeholder d-flex-center">
                        <div className="empty-provider-reviews-image empty-provider-customers-details-image" />
                        <h3
                            data-testid="no-bookings-yet-header"
                            className='empty-provider-customers-title'
                        >
                            {dictionary.no_reviews_yet}
                        </h3>
                        <div className="text empty-provider-customers-message">
                            {dictionary.all_reviews_will_be_listed}
                        </div>
                    </div>
                )
            }
        </div>
    )
}

SlotBookingReview.propTypes = {
	details: PropTypes.object
};

export default SlotBookingReview;